import { Message } from '@raven/cell';
import vuepack from '@shield/vuepack';
import { authRedirect } from '@utils/api';
const { i18n } = vuepack.cache;
const errorCode: any = [];
let isRepeatObj: { msg: string; code: number; time: number } = {
  msg: '',
  code: 0,
  time: 0,
};
function isShowErrorMsg(paramCode: number, ParamMsg: string) {
  // 1s内如果请求返回的code&message是相同的，只弹出第一次的提示
  const { msg, code, time } = isRepeatObj;
  isRepeatObj = {
    msg: ParamMsg,
    code: paramCode,
    time: Date.now(),
  };
  if (!(code === paramCode && msg === ParamMsg && Date.now() - time < 1000)) {
    Message({
      type: 'error',
      message: ParamMsg,
      duration: 2000,
    });
  }
}
function successHandle(code: number, res: any, getAll?: boolean) {
  // 调通时的处理
  const resData = res.data;
  if (getAll) {
    return res;
  } else if (code === 0) {
    /**
     * 判断 resData.data 是否为false ，是则返回false，因为后面数据处理还是需要false
     * 再判断 resData.data 是否存在，如果 resData.data 不存在 或者 为null，就返回true ==> {code:0;data:null}
     * 否则就返回 resData.data
     */
    return resData.data === false
      ? resData.data
      : resData.data
        ? resData.data
        : true;
  }
}
const request: any = {
  error: (err: any) => {
    return Promise.reject(err);
  },
  success: (request: any) => {
    const lang = (i18n.locale || '').split('-')[0];
    request.headers = {
      ...request.headers,
      'Accept-Lang': lang,
      'X-Bu': 'mpt'
    };
    const sessionToken = localStorage.user_trace_token;
    if (sessionToken) {
      request.headers['X-Authorization-With-Token'] = sessionToken;
    }
    return request;
  },
};
const response: any = {
  error: (err: any) => {
    Message.error(`${i18n.t('app.netOutTime')}`);
    return err;
  },
  success: (res: any) => {
    const code = res.data && res.data.code;
    const showMsg = res.data && res.data.code !== 0 && res.data.message;
    const msg = res.data.message ? res.data.message : `${i18n.t('app.netErr')}`;
    // 用户未登录或登录超时 跳转至登录页面
    if (code === 40401) {
      localStorage.user_trace_token = '';
      localStorage.userToken = '';
      isShowErrorMsg(code, `${i18n.t('app.notLogin')}`);
      // const query = window.document.location.searh || ''
      // console.log(query)
      authRedirect();
      return;
    }
    // 获取所有信息
    if (res.config.getAll) {
      return successHandle(code, res, res.config.getAll);
    }
    // 获取错误信息
    if (res.config.getError && errorCode.includes(code)) {
      return res.data;
    }
    // 错误提示
    if (
      (res.config.hasOwnProperty('showError') ? res.config.showError : true) &&
      showMsg
    ) {
      // Message.error(msg)
      isShowErrorMsg(code, msg);
    }
    // console.log(successHandle(code, res))
    return successHandle(code, res);
  },
};

export default {
  request,
  response,
};
